export default "/_next/static/images/app-store-fb47f0cbfc89bd8b99e0339adb04979b.svg";